module.exports = __webpack_public_path__ + "static/media/Avatar.f7be0c4b.png";